module.exports = __webpack_public_path__ + "media/images/pic/contact/katarzyna-hoffmann-bc661b9c3dc02f2fdac8d4c47b6d86e0.jpeg";